import gql from 'graphql-tag';

export const singleUpload = gql`
  mutation singleUpload ($file: Upload!, $period: Time, $type: FileType!, $resource: PermissionResource!) {
    singleUpload(file: $file, period: $period, type: $type, resource: $resource) {
      message
    }
  }
`;
